<app-enfaf-modal
  (onClose)="confirmCloseModal()"
  [svgIcon]="'message-square-dark'"
  [title]="'Añadir nuevo comentario'"
  (onConfirm)="saveComment()"
  [disableConfirmButton]="commentForm.invalid || isSavingComment"
  [buttonConfirmText]="'Enviar comentario'"
  [isLoading]="isSavingComment"
  [isComments]="true"
>
  <form [formGroup]="commentForm" autocomplete="off" class="comment-form__container">
    <div class="form-control">
      <mat-form-field color="primary" appearance="outline" class="form-control__field">
        <textarea matInput placeholder="¿Tienes alguna duda? Escribe aquí..." formControlName="message" name="commentText" autocomplete="off" rows="5" class="form-control__textarea"></textarea>
      </mat-form-field>
    </div>
  </form>
</app-enfaf-modal>